// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SdjC","select":"styles_select__2vH10"};